'use strict';

angular.module('uniromaLandingApp').factory('Esterni', 
		['$resource', 'DateUtils',function ($resource, DateUtils) {
        return $resource('api/esternis/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                	
                    data = angular.fromJson(data);
//                    data.dtNascita = DateUtils.convertLocaleDateFromServer(data.dtNascita);
                    
                    data.dataFine = DateUtils.convertLocalDateFromServer(data.dataFine);
                    data.dataAttivazione = DateUtils.convertLocalDateFromServer(data.dataAttivazione);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
//                    data.dtNascita = DateUtils.convertLocaleDateToServer(data.dtNascita);
                    //data.provResidenza = data.provResidenza.sigla;
                    return angular.toJson(data);
                }
            },
            'activate': {
                method: 'GET',
                url: 'api/activateUser/:id',
                transformRequest: function (data) {
//                    data.dtNascita = DateUtils.convertLocaleDateToServer(data.dtNascita);
                	data.dataFine = DateUtils.convertLocalDateFromServer(data.dataFine);
                    data.dataAttivazione = DateUtils.convertLocalDateFromServer(data.dataAttivazione);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                url: 'api/public/esternis',
                transformRequest: function (data) {
//                    data.dtNascita = DateUtils.convertLocaleDateToServer(data.dtNascita);
                    //data.provResidenza = data.provResidenza.sigla;
                    return angular.toJson(data);
                }
            },
            'confirmRegistration': {
                method: 'GET',
                url: 'api/public/confirm-registration/:token',
                transformRequest: function (data) {
//                    data.dtNascita = DateUtils.convertLocaleDateToServer(data.dtNascita);
                    //data.provResidenza = data.provResidenza.sigla;
                    return angular.toJson(data);
                }
            },
            'getCountryList': {
                method: 'GET',
                url: 'api/public/iso-country-codes',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        var idx = data.findIndex(function(x) {return x.nome === 'IT'});
                        if (idx >= 0) {
                            data.unshift(data.splice(idx, 1)[0]);
                        }
                    }
                    return data;
                }
            }
        });
    }]);
